import _ from 'lodash';
import EventBus from '@/event-bus';

export default {
  methods: {
    broadcastKeys(data) {
      Object.keys(data).filter(item => item !== 'data').forEach((item) => {
        EventBus.$emit(`${this.graphicId}${_.upperFirst(_.camelCase(item))}`, data[item]);
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/broadcastResponseKeys.js